import CONFIGURACIONES from "../../../../util/constants";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import React, { useState } from "react";
import OWASP from "../../../../util/owasp";

import {el, es} from "date-fns/locale";
import { parse, format } from "date-fns";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Http} from "../../../../helpers/Http";
import {Functions} from "../../../../helpers/Functions";
import AddressModal from "../../../global/modals/AddressModal";
import ActividadLaboralModal from "../../../global/modals/ActividadLaboralModal.jsx";

registerLocale("es-sunday", {
    ...es,
    options: {
        ...es.options,
        weekStartsOn: 0, // 0 = Domingo, 1 = Lunes
    },
});
const MantProspeccion = ( { MySwal, title, idEdit, user, centrosPoblado,
                              tiposDocumento, showCreate, icon, departamentos, provincias, distritos, zona, agencia,
                              changeDepartamento, changeProvincia, negocioProvincias, negocioDistritos,
                              changeDepartamentoNegocio, changeProvinciaNegocio, actividadLaboralList }) => {

    const {handleSubmit, reset, resetField, register, setValue, formState: {errors}} = useForm({mode: "onChange"});
    const [isSearchData, setIsSearchData] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [patronDocumento, setPatronDocumento] = useState(CONFIGURACIONES.INIT.STRING);
    const [fechaNacimiento, setFechaNacimiento] = useState(CONFIGURACIONES.INIT.STRING);
    const [fechaApertura, setFechaApertura] = useState(CONFIGURACIONES.INIT.STRING);
    const [tabActive, setTabActive] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [cantIntervinientes, setCantIntervinientes] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
    const [isBloqueado, setIsBloqueado] = useState(CONFIGURACIONES.INIT.STATUS_TRUE)
    const [isRenderRazonSocial, setIsRenderRazonSocial] = useState(CONFIGURACIONES.INIT.STATUS_TRUE);
    const [listaIntervinientes, setListaIntervinientes] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [fechaActual, setFechaActual] = useState(new Date());

    const [showAddressHome, setShowAddressHome] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [dataAddressHome, setDataAddressHome] = useState(CONFIGURACIONES.INIT.ADDRESS);
    const [showAddressNegocio, setShowAddressNegocio] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [dataAddressNegocio, setDataAddressNegocio] = useState(CONFIGURACIONES.INIT.ADDRESS);

    const [actividadLaboralFilter, setActividadLaboralFilter] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [showActividadLaboral, setShowActividadLaboral] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [dataActividadNegocio, setDataActividadNegocio] = useState(CONFIGURACIONES.INIT.STRING);

    const onSubmit1 = (form) => {
        form['zonaId'] = zona;
        form['agenciaId'] = agencia;
        form['numIntervinientes'] = cantIntervinientes;
        form['domicilio'] = dataAddressHome;
        form['domicilio']['tipoDireccion'] = 'DOMICILIO_PRINCIPAL';
        form['domicilio']['departamentoCodigo'] = form.departamentoCodigo;
        form['domicilio']['provinciaCodigo'] = form.provinciaCodigo;
        form['domicilio']['distritoCodigo'] = form.distritoCodigo;

        form['direccionNegocio'] = dataAddressNegocio;
        form['direccionNegocio']['tipoDireccion'] = 'NEGOCIO';
        form['direccionNegocio']['departamentoCodigo'] = form.negocioDepartamentoCodigo;
        form['direccionNegocio']['provinciaCodigo'] = form.negocioProvinciaCodigo;
        form['direccionNegocio']['distritoCodigo'] = form.negocioDistritoCodigo;

        let dataIntervinientes = [];
        listaIntervinientes.forEach((element) => {
            dataIntervinientes.push({
                'relacion': element[`relacion_${element.id}`],
                'estadoCivil': element[`estadoCivil_${element.id}`],
                'tipoDocumentoId': element[`tipoDocumentoId_${element.id}`],
                'numeroDocumento': element[`numeroDocumento_${element.id}`],
                'apellidoPaterno': element[`apellidoPaterno_${element.id}`],
                'apellidoMaterno': element[`apellidoMaterno_${element.id}`],
                'nombres': element[`nombres_${element.id}`],
                'celular': element[`celular_${element.id}`],
                'correoElectronico': element[`correoElectronico_${element.id}`],
                'genero': element[`genero_${element.id}`],
                'tipoPersona': element[`tipoPersona_${element.id}`],
                'fechaNacimiento': element[`fechaNacimiento_${element.id}`],
                'fechaApertura': element[`fechaApertura_${element.id}`],
            });
        })
        form['intervinientes'] = dataIntervinientes;

        console.log('form', form);
        createProspection(form);
    };

    const createProspection = async (form) => {
        if (!showCreate) { return; }
        await Functions().save(`${CONFIGURACIONES.ENDPOINTS.PROSPECTOS}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnReset, form);
    };

    const fnAgregarInterviniente = () => {
        setCantIntervinientes(cantIntervinientes+1)
        let idx = Functions().generarNumeroUnico(listaIntervinientes);
        let addObject= {
            id: idx,
            isBloqueado: CONFIGURACIONES.INIT.STATUS_TRUE,
            patronDocumento: '',
            isRenderRazonSocial: CONFIGURACIONES.INIT.STATUS_TRUE,
            fechaNacimiento: CONFIGURACIONES.INIT.STRING,
            fechaApertura: CONFIGURACIONES.INIT.STRING
        };
        setListaIntervinientes((prev) => [...prev, addObject]);
    };

    const fnDeleteInterviniente = (idx) => {
        setListaIntervinientes((prev) => prev.filter((el) => el.id !== idx));
    };

    const fnCollapse = (value) => {
        setTabActive(value);
        setIconActive('fa-chevron-up')
    };

    const fnReset = () => {
        setDataAddressNegocio(CONFIGURACIONES.INIT.ADDRESS);
        setDataAddressNegocio(CONFIGURACIONES.INIT.ADDRESS);
        setIsBloqueado(CONFIGURACIONES.INIT.STATUS_TRUE);
        setFechaNacimiento(CONFIGURACIONES.INIT.STRING);
        setFechaApertura(CONFIGURACIONES.INIT.STRING);
        setListaIntervinientes(CONFIGURACIONES.INIT.ARRAY);
        setCantIntervinientes(CONFIGURACIONES.INIT.NUMBER);
        reset();
    };

    const fnActualizarCliente = (data, isFormPrinc=CONFIGURACIONES.INIT.STATUS_TRUE, idx = CONFIGURACIONES.INIT.STRING) => {
        if (isFormPrinc) {
            setValue('apellidoPaterno', data?.apellidoPaterno);
            setValue('apellidoMaterno', data?.apellidoMaterno);
            setValue('nombres', data?.nombres);
            setValue('fechaNacimiento', data?.fechaNacimiento);
            setValue('fechaApertura', data?.fechaNacimiento);
            setValue('genero', data?.genero);
            setValue('estadoCivil', data?.estadoCivil);
            setValue('tipoPersona', data?.tipoPersona);
            setValue('celular', data?.celular);
            setValue('correoElectronico', data?.correoElectronico);
            setValue('fuenteIngreso', data?.fuenteIngreso);
            setValue('estadoPersona', data?.estadoPersona);
            setFechaNacimiento(parse(data?.fechaNacimiento, "yyyy-MM-dd", new Date()));
            setFechaApertura(parse(data?.fechaNacimiento, "yyyy-MM-dd", new Date()));
        } else {
            setValue(`apellidoPaterno_${idx}`, data?.apellidoPaterno);
            setValue(`apellidoMaterno_${idx}`, data?.apellidoMaterno);
            setValue(`nombres_${idx}`, data?.nombres);
            setValue(`fechaNacimiento_${idx}`, data?.fechaNacimiento);
            setValue(`genero_${idx}`, data?.genero);
            setValue(`estadoCivil_${idx}`, data?.estadoCivil);
            setValue(`celular_${idx}`, data?.celular);
            setValue(`correoElectronico_${idx}`, data?.correoElectronico);
        }

    };

    const fnActualizarDirecciones = (data) => {
        setValue('departamentoCodigo', data?.domicilio.departamentoCodigo);
        changeDepartamento(data.domicilio.departamentoCodigo);
        setValue('provinciaCodigo', data?.domicilio.provinciaCodigo);
        changeProvincia(data.domicilio.provinciaCodigo);
        setValue('distritoCodigo', data?.domicilio.distritoCodigo);

        let form = {
            calle: data.domicilio.calle,
            numero: data.domicilio.numero,
            interior: data.domicilio.interior,
            telefono: data.domicilio.telefono,
            manzana: data.domicilio.manzana,
            lote: data.domicilio.lote,
            tipoZona: data.domicilio.tipoZona,
            nombreZona: data.domicilio.nombreZona,
            referencia: data.domicilio.referencia,
            centroPobladoSelect: `${data.domicilio.centroPobladoId}@@${data.domicilio.centroPobladoNombre}`,
            centroPobladoNombre: data.domicilio.centroPobladoNombre,
            centroPobladoId: data.domicilio.centroPobladoId,
            tipoUbicacion: data.domicilio.tipoUbicacion
        }

        console.log('form home', form);
        
        setDataAddressHome(form);
        let nombreZona = form.nombreZona;
        if (form.tipoZona === CONFIGURACIONES.INIT.TYPE_ZONE_CENTRO_POBLADO) {
            nombreZona = form.centroPobladoNombre;
        }
        setValue("direccion", `${form.calle}, ${form.numero}, ${form.interior}, ${form.manzana}, ${form.lote}, ${form.tipoZona} ${nombreZona}, ${form.referencia}`)

        setValue('negocioDepartamentoCodigo', data?.negocio.departamentoCodigo);
        changeDepartamentoNegocio(data.negocio.departamentoCodigo);
        setValue('negocioProvinciaCodigo', data?.negocio.provinciaCodigo);
        changeProvinciaNegocio(data.negocio.provinciaCodigo);
        setValue('negocioDistritoCodigo', data?.negocio.distritoCodigo);

        let formNegocio = {
            calle: data.negocio.calle,
            numero: data.negocio.numero,
            interior: data.negocio.interior,
            telefono: data.negocio.telefono,
            manzana: data.negocio.manzana,
            lote: data.negocio.lote,
            tipoZona: data.negocio.tipoZona,
            nombreZona: data.negocio.nombreZona,
            referencia: data.negocio.referencia,
            centroPobladoSelect: `${data.negocio.centroPobladoId}@@${data.negocio.centroPobladoNombre}`,
            centroPobladoNombre: data.negocio.centroPobladoNombre,
            centroPobladoId: data.negocio.centroPobladoId,
            tipoUbicacion: data.negocio.tipoUbicacion
        }
        setDataAddressNegocio(formNegocio);
        let negocioNombreZona = formNegocio.nombreZona;
        if (formNegocio.tipoZona === CONFIGURACIONES.INIT.TYPE_ZONE_CENTRO_POBLADO) {
            negocioNombreZona = formNegocio.centroPobladoNombre;
        }
        setValue("negocioDireccion", `${formNegocio.calle}, ${formNegocio.numero}, ${formNegocio.interior}, ${formNegocio.manzana}, ${formNegocio.lote}, ${negocioNombreZona} ${formNegocio.nombreZona}, ${formNegocio.referencia}`)


    };

    const fetchClient = (tipoDocumentoId, numeroDocumento, isFormPrinc=CONFIGURACIONES.INIT.STATUS_TRUE, idx = CONFIGURACIONES.INIT.STRING) => {
        if (tipoDocumentoId && numeroDocumento) {
            let data = {
                body: {
                    'tipoDocumentoId': tipoDocumentoId,
                    'numeroDocumento': numeroDocumento,
                    'usuarioRegistro': user.user
                }
            }
            setIsSearchData(CONFIGURACIONES.INIT.STATUS_FALSE);
            Http().post(`${CONFIGURACIONES.ENDPOINTS.CLIENTES}/buscar`, data).then((rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    MySwal.fire({
                        title: `<p>${CONFIGURACIONES.MESSAGES.TITLE}</p>`,
                        html: `${CONFIGURACIONES.MESSAGES.SUCCESS_SEARCH_OPERATION}
                                ${rpta.data ? '' : '<br><small class="text-danger">No se obtuvo resultados, registre por favor.</small>'}
                            `,
                        icon: 'success',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        cancelButtonColor: "#f62d51",
                        confirmButtonColor: "#2962FF"
                    }).then((result) => {
                        if (isFormPrinc) {
                            setIsBloqueado(CONFIGURACIONES.INIT.STATUS_FALSE);
                            setIsRenderRazonSocial(CONFIGURACIONES.INIT.STATUS_TRUE);
                            if (tipoDocumentoId != CONFIGURACIONES.INIT.TYPE_DOCUMENT_RUC) {
                                setIsRenderRazonSocial(CONFIGURACIONES.INIT.STATUS_FALSE);
                            }

                            fnActualizarCliente(rpta.data);
                            fnActualizarDirecciones(rpta.data);
                            setDataActividadNegocio(`${rpta.data.actividadNegocioId}@@${rpta.data.actividadNegocioNombre}`);
                            setValue("actividadNegocioId", rpta.data.actividadNegocioId);
                            setValue("actividadLaboral", rpta.data.actividadNegocioNombre);
                            setIsSearchData(CONFIGURACIONES.INIT.STATUS_TRUE);
                        } else {
                            setListaIntervinientes(prev =>
                                prev.map(item => item.id === idx?
                                    {...item, isBloqueado: CONFIGURACIONES.INIT.STATUS_FALSE,
                                        isRenderRazonSocial: (tipoDocumentoId != CONFIGURACIONES.INIT.TYPE_DOCUMENT_RUC?
                                            CONFIGURACIONES.INIT.STATUS_FALSE:CONFIGURACIONES.INIT.STATUS_TRUE) }
                                    : item
                                )
                            );
                            console.log('lista', listaIntervinientes);
                            fnActualizarCliente(rpta.data, CONFIGURACIONES.INIT.STATUS_FALSE, idx);
                        }
                    });
                } else {
                    MySwal.fire({
                        title: `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                        html: `${Object.keys(rpta.errors).length ? Functions().showErrors(rpta.errors) : rpta.message}`,
                        icon: 'error',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        cancelButtonColor: "#f62d51",
                        confirmButtonColor: "#2962FF"
                    });
                }
            });
        } else {
            MySwal.fire({
                title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                html: `Indique <strong>Tipo de Documento</strong> y <strong>Número de Documento</strong> para realizar búsqueda`,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#f62d51",
                confirmButtonColor: "#2962FF"
            });
        }
    };
    const fnBuscar = () => {
        let tipoDocumentoId = document.getElementById('tipoDocumentoId').value;
        let numeroDocumento = document.getElementById('numeroDocumento').value;

        fetchClient(tipoDocumentoId, numeroDocumento);
    };


    const fnBuscarInterviniente = (idx) => {
        let tipoDocumentoId = document.getElementById(`tipoDocumentoId_${idx}`).value;
        let numeroDocumento = document.getElementById(`numeroDocumento_${idx}`).value;

        console.log(`tipoDocumentoId: ${tipoDocumentoId} - numeroDocumento: ${numeroDocumento}`);
        fetchClient(tipoDocumentoId, numeroDocumento, CONFIGURACIONES.INIT.STATUS_FALSE, idx);
    };

    const fnShowAddress = () => {
        setShowAddressHome(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnCloseAddress = () => {
        setShowAddressHome(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnSaveAddressHome = (form) => {
        console.log('form', form)
        setDataAddressHome(form);
        let nombreZona = form.nombreZona;
        if (form.tipoZona === CONFIGURACIONES.INIT.TYPE_ZONE_CENTRO_POBLADO) {
            nombreZona = form.centroPobladoNombre;
        }

        setValue("direccion", `${form.calle}, ${form.numero}, ${form.interior}, ${form.manzana}, ${form.lote}, ${form.tipoZona} ${nombreZona}, ${form.referencia}`)
        fnCloseAddress();
    };

    const fnShowAddressNegocio = () => {
        setShowAddressNegocio(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnCloseAddressNegocio = () => {
        setShowAddressNegocio(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnSaveAddressNegocio = (form) => {
        console.log('form', form)
        setDataAddressNegocio(form);
        let nombreZona = form.nombreZona;
        if (form.tipoZona === CONFIGURACIONES.INIT.TYPE_ZONE_CENTRO_POBLADO) {
            nombreZona = form.centroPobladoNombre;
        }
        setValue("negocioDireccion", `${form.calle}, ${form.numero}, ${form.interior}, ${form.manzana}, ${form.lote}, ${form.tipoZona} ${nombreZona}, ${form.referencia}`)
        fnCloseAddressNegocio();
    };

    const fnShowActividadNegocio = () => {
        let fuenteIngreso = document.getElementById('fuenteIngreso').value;
        console.log('fuenteIngreso', fuenteIngreso);
        console.log('actividadLaboralList', actividadLaboralList);

        setActividadLaboralFilter(actividadLaboralList.filter((el) => el.tipo_fuente_ingreso === fuenteIngreso));
        setShowActividadLaboral(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnCloseActividadNegocio = () => {
        setShowActividadLaboral(CONFIGURACIONES.INIT.STATUS_FALSE);
    }

    const fnSaveActividadNegocio = (form) => {
        console.log('form', form)
        setDataActividadNegocio(form.actividadLaboral);
        let dataActividad = form.actividadLaboral.split('@@');
        setValue("actividadNegocioId", dataActividad[0]);
        setValue("actividadLaboral", dataActividad[1]);
        fnCloseActividadNegocio();
    };

    return (
        <>
            { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
                <div className="card-content">
                    <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                        <div className="row">
                            <div className="col-xs-12 col-md-11">
                                <h5 className="card-title font-weight-bold"><i className={`mdi ${icon}`}></i> {title}</h5>
                                <div className="row">
                                    <div className="col-sm-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="estadoCliente" className="control-label col-form-label">Estado <span className="text-danger">*</span></label>
                                            <select
                                                {...register("estadoCliente", {
                                                    required: OWASP.REQUIRED,
                                                    onChange: (e) => {

                                                    }
                                                })} className="form-control" id="estadoCliente"  defaultValue={""}
                                            >
                                                {
                                                    CONFIGURACIONES.INIT.LIST.ESTADOS_PROSPECCION.map((el, index) => (
                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <small className="invalid-feedback"> { errors.estadoCliente && errors.estadoCliente.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="tipoDocumentoRefId" className="control-label col-form-label">Tipo de Documento <span className="text-danger">*</span></label>
                                            <select
                                                {...register("tipoDocumentoRefId", {
                                                    required: OWASP.REQUIRED,
                                                    onChange:(e) => {
                                                        setPatronDocumento(new RegExp(e.target.value.split('@@')[1]));
                                                        setValue("tipoDocumentoId", e.target.value.split('@@')[0]);
                                                        setIsBloqueado(CONFIGURACIONES.INIT.STATUS_TRUE);
                                                        setIsSearchData(CONFIGURACIONES.INIT.STATUS_FALSE);
                                                        resetField("numeroDocumento");
                                                    }
                                                })} className="form-control" id="tipoDocumentoRefId"
                                                defaultValue={""}
                                            >
                                                <option value="" disabled>Seleccione</option>
                                                {
                                                    tiposDocumento.map((el, index) => (
                                                        <option key={index} value={`${el.id}@@${el.patron_validacion}`}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <input
                                                {...register("tipoDocumentoId", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                                id="tipoDocumentoId"
                                                type="hidden" />
                                            <small className="invalid-feedback"> { errors.tipoDocumentoId && errors.tipoDocumentoId.message }</small>
                                        </div>
                                    </div>


                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="numeroDocumento" className="control-label col-form-label">Num. de Documento <span className="text-danger">*</span></label>
                                            <input
                                                {...register("numeroDocumento", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: patronDocumento,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    onChange: (e) => {
                                                        setIsBloqueado(CONFIGURACIONES.INIT.STATUS_TRUE);
                                                        setIsSearchData(CONFIGURACIONES.INIT.STATUS_FALSE);
                                                    }
                                                })}
                                                type="text" className="form-control" id="numeroDocumento" placeholder="" />
                                            <small className="invalid-feedback"> { errors.numeroDocumento && errors.numeroDocumento.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-1 my-auto pt-3">
                                        <button type="button" className="btn btn-sm btn-info" onClick={fnBuscar}>
                                            <i className="mdi mdi-magnify"></i>
                                        </button>
                                    </div>
                                </div>

                                {!isRenderRazonSocial && <div className="row">
                                    <div className="col-xs-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="apellidoPaterno" className="control-label col-form-label">Apellido Paterno <span
                                                className="text-danger">*</span></label>
                                            <input type="text"
                                                   {...register("apellidoPaterno", {
                                                       required: OWASP.REQUIRED,
                                                       pattern: {
                                                           value: OWASP.VALIDATIONS.GENERAL,
                                                           message: OWASP.MESSAGES.DEFAULT
                                                       },
                                                       disabled: isBloqueado
                                                   })}
                                                   className="form-control" id="apellidoPaterno"/>
                                            <small
                                                className="invalid-feedback"> {errors.apellidoPaterno && errors.apellidoPaterno.message}</small>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="apellidoMaterno" className="control-label col-form-label">Apellido Materno <span
                                                className="text-danger">*</span></label>
                                            <input type="text"
                                                   {...register("apellidoMaterno", {
                                                       required: OWASP.REQUIRED,
                                                       pattern: {
                                                           value: OWASP.VALIDATIONS.GENERAL,
                                                           message: OWASP.MESSAGES.DEFAULT
                                                       },
                                                       disabled: isBloqueado
                                                   })}
                                                   className="form-control" id="apellidoMaterno"/>
                                            <small
                                                className="invalid-feedback"> {errors.apellidoMaterno && errors.apellidoMaterno.message}</small>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-5">
                                        <div className="form-group">
                                            <label htmlFor="nombres" className="control-label col-form-label">Nombres <span
                                                className="text-danger">*</span></label>
                                            <input type="text"
                                                   {...register("nombres", {
                                                       required: OWASP.REQUIRED,
                                                       pattern: {
                                                           value: OWASP.VALIDATIONS.GENERAL,
                                                           message: OWASP.MESSAGES.DEFAULT
                                                       },
                                                       disabled: isBloqueado
                                                   })}
                                                   className="form-control" id="nombres"/>
                                            <small
                                                className="invalid-feedback"> {errors.nombres && errors.nombres.message}</small>
                                        </div>
                                    </div>
                                </div>
                                }
                                <div className="row">
                                    {isRenderRazonSocial &&  <div className="col-xs-12 col-md-5">
                                        <div className="form-group">
                                            <label htmlFor="nombres" className="control-label col-form-label">Razón Social <span
                                                className="text-danger">*</span></label>
                                            <input type="text"
                                                   {...register("nombres", {
                                                       required: OWASP.REQUIRED,
                                                       pattern: {
                                                           value: OWASP.VALIDATIONS.GENERAL,
                                                           message: OWASP.MESSAGES.DEFAULT
                                                       },
                                                       disabled: isBloqueado
                                                   })}
                                                   className="form-control" id="nombres"/>
                                            <small
                                                className="invalid-feedback"> {errors.nombres && errors.nombres.message}</small>
                                        </div>
                                    </div>}

                                    <div className="col-sm-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="tipoPersona" className="control-label col-form-label">Tipo de Cliente <span className="text-danger">*</span></label>
                                            <select
                                                {...register("tipoPersona", {
                                                    required: OWASP.REQUIRED,
                                                    onChange: (e) => {

                                                    },
                                                    disabled: isBloqueado
                                                })} className="form-control" id="tipoPersona"  defaultValue={""}
                                            >
                                                <option value="" disabled>Seleccione</option>
                                                {
                                                    CONFIGURACIONES.INIT.LIST.TIPOS_CLIENTE.map((el, index) => (
                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <small className="invalid-feedback"> { errors.tipoPersona && errors.tipoPersona.message }</small>
                                        </div>
                                    </div>

                                    {!isRenderRazonSocial && <div className="col-xs-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="fechaNacimiento" className="control-label col-form-label">Fecha
                                                de Nacimiento <span className="text-danger">*</span></label>
                                            <DatePicker dateFormat={"dd/MM/yyyy"}
                                                        id="fechaNacimientoDatePicker"
                                                        placeholderText="dd / mm / aaaa"
                                                        className="form-control text-center"
                                                        locale="es-sunday"
                                                        selected={fechaNacimiento}
                                                        disabled={isBloqueado}
                                                        dayClassName={(date) =>
                                                            date.getDay() === 0 || date.getDay() === 6 ? "weekend-day" : undefined
                                                        }
                                                        onChange={(date) => {
                                                            setFechaNacimiento(date);
                                                            setValue("fechaNacimiento", format(date, "yyyy-MM-dd"),
                                                                {shouldValidate: true});
                                                        }}
                                                        onChangeRaw={(e) => e.preventDefault()}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        popperClassName="datepicker-popper"
                                                        maxDate={fechaActual}
                                            />
                                            <input
                                                {...register("fechaNacimiento", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.DATE,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                                type="hidden"/>
                                            <small
                                                className="invalid-feedback"> {errors.fechaNacimiento && errors.fechaNacimiento.message}</small>
                                        </div>
                                    </div>}

                                    {isRenderRazonSocial && <div className="col-xs-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="fechaApertura" className="control-label col-form-label">Inicio de Actividades <span className="text-danger">*</span></label>
                                            <DatePicker dateFormat={"dd/MM/yyyy"}
                                                        id="fechaAperturaDatePicker"
                                                        placeholderText="dd / mm / aaaa"
                                                        className="form-control text-center"
                                                        locale="es-sunday"
                                                        disabled={isBloqueado}
                                                        selected={fechaApertura}
                                                        dayClassName={(date) =>
                                                            date.getDay() === 0 || date.getDay() === 6 ? "weekend-day" : undefined
                                                        }
                                                        onChange={(date) => {
                                                            setFechaApertura(date);
                                                            setValue("fechaApertura", format(date, "yyyy-MM-dd"),
                                                                {shouldValidate: true});
                                                        }}
                                                        onChangeRaw={(e) => e.preventDefault()}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        popperClassName="datepicker-popper"
                                                        maxDate={fechaActual}
                                            />
                                            <input
                                                {...register("fechaApertura", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.DATE,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                                type="hidden"/>
                                            <small
                                                className="invalid-feedback"> {errors.fechaApertura && errors.fechaApertura.message}</small>
                                        </div>
                                    </div>}

                                    {!isRenderRazonSocial && <div className={`col-sm-12 ${isRenderRazonSocial ? 'col-md-2' : 'col-md-3'}`}>
                                        <div className="form-group">
                                            <label htmlFor="genero" className="control-label col-form-label">Género <span
                                                className="text-danger">*</span></label>
                                            <select
                                                {...register("genero", {
                                                    required: OWASP.REQUIRED,
                                                    disabled: isBloqueado
                                                })} className="form-control" id="genero"
                                                placeholder="" defaultValue={""}
                                            >
                                                <option value="" disabled>Seleccione</option>

                                                {
                                                    CONFIGURACIONES.INIT.LIST.GENEROS.map((el, index) => (
                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <small
                                                className="invalid-feedback"> {errors.genero && errors.genero.message}</small>
                                        </div>
                                    </div>}

                                    {!isRenderRazonSocial && <div className="col-xs-12 col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="estadoCivil" className="control-label col-form-label">Estado
                                                Civil <span className="text-danger">*</span></label>
                                            <select
                                                {...register("estadoCivil", {
                                                    required: OWASP.REQUIRED,
                                                    onChange: (e) => {

                                                    },
                                                    disabled: isBloqueado
                                                })} className="form-control" id="estadoCivil" defaultValue={""}
                                            >
                                                <option value="" disabled>Seleccione</option>
                                                {
                                                    CONFIGURACIONES.INIT.LIST.ESTADOS_CIVIL.map((el, index) => (
                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <small
                                                className="invalid-feedback"> {errors.estadoCivil && errors.estadoCivil.message}</small>
                                        </div>
                                    </div>}

                                    <div className="col-sm-12 col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="celular" className="control-label col-form-label">Celular <span className="text-danger">*</span></label>
                                            <input
                                                {...register("celular", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    disabled: isBloqueado
                                                })}
                                                type="tel" className="form-control" id="celular" placeholder="" maxLength={12}/>
                                            <small className="invalid-feedback"> { errors.celular && errors.celular.message }</small>
                                        </div>
                                    </div>

                                    <div className={`col-sm-12 ${isRenderRazonSocial?'col-md-6':'col-md-9'}`}>
                                        <div className="form-group">
                                            <label htmlFor="correoElectronico" className="control-label col-form-label">Email </label>
                                            <input
                                                {...register("correoElectronico", {
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.EMAIL,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    disabled: isBloqueado
                                                })}
                                                type="email" className="form-control" id="correoElectronico" placeholder="" />
                                            <small className="invalid-feedback"> { errors.correoElectronico && errors.correoElectronico.message }</small>
                                        </div>
                                    </div>

                                </div>
                                <hr/>
                                <div className="row mt-1">
                                    <div className="col-md-12">
                                        <div className="d-flex align-items-center pb-2">
                                            <h6 className="mr-2 mb-0">Datos de los Intervinientes</h6>

                                            <WaveButton type="button" disabled={isBloqueado} className="btn btn-sm btn-outline-danger waves-effect" dataTooltipId="add_interviniente" place="right"
                                                        content="Agregar Interviniente" onClick={fnAgregarInterviniente}>
                                                <i className="mdi mdi-plus"></i>
                                            </WaveButton>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div id="accordion">
                                            {listaIntervinientes.map((inter, index) => (
                                                <React.Fragment key={inter.id}>
                                                    <div className="card">
                                                        <div className="card-header" id={`heading_${inter.id}`} onClick={() => fnCollapse(inter.id)}>
                                                            <h5 className="mb-0">
                                                                <button type="button"
                                                                        className="btn btn-link d-flex justify-content-between align-items-center w-100 pl-0"
                                                                        data-toggle="collapse"
                                                                        data-target={`#collapse_${inter.id}`} aria-expanded="true"
                                                                        aria-controls={`#collapse_${inter.id}`}>
                                                                    <span>Interviniente {index + 1}</span>
                                                                    <i className={`fa ${tabActive === inter.id?"fa-chevron-up":"fa fa-chevron-down"}`}></i>
                                                                </button>
                                                            </h5>
                                                        </div>

                                                        {inter.id === tabActive && <div id={`collapse_${inter.id}`} className="collapse"
                                                                                        aria-labelledby={`heading_${inter.id}`} data-parent="#accordion">
                                                            <div className="card-body p-2">
                                                                <div className="row">
                                                                    <div className="col-sm-12 col-md-3">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`tipoDocumentoRefId_${inter.id}`} className="control-label col-form-label">Tipo de Documento <span className="text-danger">*</span></label>
                                                                            <select
                                                                                {...register(`tipoDocumentoRefId_${inter.id}`, {
                                                                                    required: OWASP.REQUIRED,
                                                                                    onChange:(e) => {
                                                                                        setListaIntervinientes(prev =>
                                                                                            prev.map(item => item.id === inter.id?
                                                                                                {...item, patronDocumento: new RegExp(e.target.value.split('@@')[1]), isBloqueado: CONFIGURACIONES.INIT.STATUS_TRUE }
                                                                                                : item
                                                                                            )
                                                                                        );
                                                                                        setValue(`tipoDocumentoId_${inter.id}`, e.target.value.split('@@')[0]);
                                                                                    }
                                                                                })} className="form-control" id={`tipoDocumentoRefId_${inter.id}`}
                                                                                defaultValue={""}
                                                                            >
                                                                                <option value="" disabled>Seleccione</option>
                                                                                {
                                                                                    tiposDocumento.map((el, index) => (
                                                                                        <option key={index} value={`${el.id}@@${el.patron_validacion}`}>{el.nombre}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <input
                                                                                {...register(`tipoDocumentoId_${inter.id}`, {
                                                                                    required: OWASP.REQUIRED,
                                                                                    pattern: {
                                                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                                    }
                                                                                })}
                                                                                id={`tipoDocumentoId_${inter.id}`}
                                                                                type="hidden" />
                                                                            <small className="invalid-feedback"> { errors[`tipoDocumentoId_${inter.id}`]?.message }</small>
                                                                        </div>
                                                                    </div>


                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`numeroDocumento_${inter.id}`} className="control-label col-form-label">Num. de Documento <span className="text-danger">*</span></label>
                                                                            <input
                                                                                {...register(`numeroDocumento_${inter.id}`, {
                                                                                    required: OWASP.REQUIRED,
                                                                                    pattern: {
                                                                                        value: inter.patronDocumento,
                                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                                    },
                                                                                    onChange: (e) => {
                                                                                        setListaIntervinientes(prev =>
                                                                                            prev.map(item => item.id === inter.id?
                                                                                                {...item, isBloqueado: CONFIGURACIONES.INIT.STATUS_TRUE }
                                                                                                : item
                                                                                            )
                                                                                        );
                                                                                    }
                                                                                })}
                                                                                type="text" className="form-control" id={`numeroDocumento_${inter.id}`} placeholder="" />
                                                                            <small className="invalid-feedback"> { errors[`numeroDocumento_${inter.id}`]?.message }</small>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-sm-1 my-auto pt-3">
                                                                        <button type="button" className="btn btn-sm btn-info" onClick={() => fnBuscarInterviniente(inter.id)}>
                                                                            <i className="mdi mdi-magnify"></i>
                                                                        </button>
                                                                    </div>

                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`tipoInterviniente_${inter.id}`} className="control-label col-form-label">Relación <span className="text-danger">*</span></label>
                                                                            <select
                                                                                {...register(`tipoInterviniente_${inter.id}`, {
                                                                                    required: OWASP.REQUIRED,
                                                                                    onChange: (e) => {

                                                                                    },
                                                                                    disabled: inter.isBloqueado
                                                                                })} className="form-control" id={`tipoInterviniente_${inter.id}`}  defaultValue={""}
                                                                            >
                                                                                <option value="" disabled>Seleccione</option>
                                                                                {
                                                                                    CONFIGURACIONES.INIT.LIST.RELACION_INTERVENIENTES.map((el, index) => (
                                                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <small className="invalid-feedback"> { errors[`tipoInterviniente_${inter.id}`]?.message }</small>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {!inter.isRenderRazonSocial && <div className="row">
                                                                    <div className="col-xs-12 col-md-3">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`apellidoPaterno_${inter.id}`}
                                                                                   className="control-label col-form-label">Apellido
                                                                                Paterno <span
                                                                                    className="text-danger">*</span></label>
                                                                            <input type="text"
                                                                                   {...register(`apellidoPaterno_${inter.id}`, {
                                                                                       required: OWASP.REQUIRED,
                                                                                       pattern: {
                                                                                           value: OWASP.VALIDATIONS.GENERAL,
                                                                                           message: OWASP.MESSAGES.DEFAULT
                                                                                       },
                                                                                       disabled: inter.isBloqueado
                                                                                   })}
                                                                                   className="form-control"
                                                                                   id={`apellidoPaterno_${inter.id}`}/>
                                                                            <small
                                                                                className="invalid-feedback"> {errors[`apellidoPaterno_${inter.id}`]?.message}</small>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xs-12 col-md-3">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`apellidoMaterno_${inter.id}`}
                                                                                   className="control-label col-form-label">Apellido
                                                                                Materno <span
                                                                                    className="text-danger">*</span></label>
                                                                            <input type="text"
                                                                                   {...register(`apellidoMaterno_${inter.id}`, {
                                                                                       required: OWASP.REQUIRED,
                                                                                       pattern: {
                                                                                           value: OWASP.VALIDATIONS.GENERAL,
                                                                                           message: OWASP.MESSAGES.DEFAULT
                                                                                       },
                                                                                       disabled: inter.isBloqueado
                                                                                   })}
                                                                                   className="form-control"
                                                                                   id={`apellidoMaterno_${inter.id}`}/>
                                                                            <small
                                                                                className="invalid-feedback"> {errors[`apellidoMaterno_${inter.id}`]?.message}</small>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xs-12 col-md-6">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`nombres_${inter.id}`}
                                                                                   className="control-label col-form-label">Nombres <span
                                                                                className="text-danger">*</span></label>
                                                                            <input type="text"
                                                                                   {...register(`nombres_${inter.id}`, {
                                                                                       required: OWASP.REQUIRED,
                                                                                       pattern: {
                                                                                           value: OWASP.VALIDATIONS.GENERAL,
                                                                                           message: OWASP.MESSAGES.DEFAULT
                                                                                       },
                                                                                       disabled: inter.isBloqueado
                                                                                   })}
                                                                                   className="form-control"
                                                                                   id={`nombres_${inter.id}`}/>
                                                                            <small
                                                                                className="invalid-feedback"> {errors[`nombres_${inter.id}`]?.message}</small>
                                                                        </div>
                                                                    </div>
                                                                </div>}

                                                                <div className="row">
                                                                    {inter.isRenderRazonSocial &&  <div className="col-xs-12 col-md-5">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`nombres_${inter.id}`} className="control-label col-form-label">Razón Social <span
                                                                                className="text-danger">*</span></label>
                                                                            <input type="text"
                                                                                   {...register(`nombres_${inter.id}`, {
                                                                                       required: OWASP.REQUIRED,
                                                                                       pattern: {
                                                                                           value: OWASP.VALIDATIONS.GENERAL,
                                                                                           message: OWASP.MESSAGES.DEFAULT
                                                                                       },
                                                                                       disabled: inter.isBloqueado
                                                                                   })}
                                                                                   className="form-control" id={`nombres_${inter.id}`}/>
                                                                            <small
                                                                                className="invalid-feedback"> {errors[`nombres_${inter.id}`]?.message}</small>
                                                                        </div>
                                                                    </div>}

                                                                    <div className="col-sm-12 col-md-3">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`tipoPersona_${inter.id}`} className="control-label col-form-label">Tipo de Interviniente <span className="text-danger">*</span></label>
                                                                            <select
                                                                                {...register(`tipoPersona_${inter.id}`, {
                                                                                    required: OWASP.REQUIRED,
                                                                                    onChange: (e) => {

                                                                                    },
                                                                                    disabled: inter.isBloqueado
                                                                                })} className="form-control" id={`tipoPersona_${inter.id}`}  defaultValue={""}
                                                                            >
                                                                                <option value="" disabled>Seleccione</option>
                                                                                {
                                                                                    CONFIGURACIONES.INIT.LIST.TIPOS_CLIENTE.map((el, index) => (
                                                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <small className="invalid-feedback"> { errors[`tipoPersona_${inter.id}`]?.message }</small>
                                                                        </div>
                                                                    </div>

                                                                    {!inter.isRenderRazonSocial && <div className="col-xs-12 col-md-3">
                                                                        <div className="form-group">
                                                                            <label
                                                                                htmlFor={`fechaNacimiento_${inter.id}`}
                                                                                className="control-label col-form-label">Fecha
                                                                                de Nacimiento <span
                                                                                    className="text-danger">*</span></label>
                                                                            <DatePicker dateFormat={"dd/MM/yyyy"}
                                                                                        id={`fechaNacimientoDatePicker_${inter.id}`}
                                                                                        placeholderText="dd / mm / aaaa"
                                                                                        className="form-control text-center"
                                                                                        locale="es-sunday"
                                                                                        disabled={inter.isBloqueado}
                                                                                        selected={inter.fechaNacimiento}
                                                                                        dayClassName={(date) =>
                                                                                            date.getDay() === 0 || date.getDay() === 6 ? "weekend-day" : undefined
                                                                                        }
                                                                                        onChange={(date) => {
                                                                                            setValue(`fechaNacimiento_${inter.id}`, format(date, "yyyy-MM-dd"),
                                                                                                {shouldValidate: true});
                                                                                            setListaIntervinientes(prev =>
                                                                                                prev.map(item => item.id === inter.id?
                                                                                                    {...item, fechaNacimiento: date }
                                                                                                    : item
                                                                                                )
                                                                                            );
                                                                                        }}
                                                                                        onChangeRaw={(e) => e.preventDefault()}
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        popperClassName="datepicker-popper"
                                                                                        maxDate={fechaActual}
                                                                            />
                                                                            <input
                                                                                {...register(`fechaNacimiento_${inter.id}`, {
                                                                                    required: OWASP.REQUIRED,
                                                                                    pattern: {
                                                                                        value: OWASP.VALIDATIONS.DATE,
                                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                                    }
                                                                                })}
                                                                                type="hidden"/>
                                                                            <small
                                                                                className="invalid-feedback"> {errors[`fechaNacimiento_${inter.id}`]?.message}</small>
                                                                        </div>
                                                                    </div>}

                                                                    {inter.isRenderRazonSocial && <div className="col-xs-12 col-md-4">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`fechaApertura_${inter.id}`} className="control-label col-form-label">Inicio de Actividades <span className="text-danger">*</span></label>
                                                                            <DatePicker dateFormat={"dd/MM/yyyy"}
                                                                                        id={`fechaAperturaDatePicker_${inter.id}`}
                                                                                        placeholderText="dd / mm / aaaa"
                                                                                        className="form-control text-center"
                                                                                        locale="es-sunday"
                                                                                        disabled={inter.isBloqueado}
                                                                                        selected={inter.fechaApertura}
                                                                                        dayClassName={(date) =>
                                                                                            date.getDay() === 0 || date.getDay() === 6 ? "weekend-day" : undefined
                                                                                        }
                                                                                        onChange={(date) => {
                                                                                            setValue(`fechaApertura_${inter.id}`, format(date, "yyyy-MM-dd"),
                                                                                                {shouldValidate: true});
                                                                                            setListaIntervinientes(prev =>
                                                                                                prev.map(item => item.id === inter.id?
                                                                                                    {...item, fechaApertura: date }
                                                                                                    : item
                                                                                                )
                                                                                            );
                                                                                        }}
                                                                                        onChangeRaw={(e) => e.preventDefault()}
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        popperClassName="datepicker-popper"
                                                                                        maxDate={fechaActual}
                                                                            />
                                                                            <input
                                                                                {...register(`fechaApertura_${inter.id}`, {
                                                                                    required: OWASP.REQUIRED,
                                                                                    pattern: {
                                                                                        value: OWASP.VALIDATIONS.DATE,
                                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                                    }
                                                                                })}
                                                                                type="hidden"/>
                                                                            <small
                                                                                className="invalid-feedback"> {errors[`fechaApertura_${inter.id}`]?.message}</small>
                                                                        </div>
                                                                    </div>}

                                                                    {!inter.isRenderRazonSocial && <div
                                                                        className={`col-sm-12 ${inter.isRenderRazonSocial ? 'col-md-2' : 'col-md-3'}`}>
                                                                        <div className="form-group">
                                                                            <label htmlFor={`genero_${inter.id}`}
                                                                                   className="control-label col-form-label">Género <span
                                                                                className="text-danger">*</span></label>
                                                                            <select
                                                                                {...register(`genero_${inter.id}`, {
                                                                                    required: OWASP.REQUIRED,
                                                                                    disabled: inter.isBloqueado
                                                                                })} className="form-control" id={`genero_${inter.id}`}
                                                                                placeholder="" defaultValue={""}
                                                                            >
                                                                                <option value="" disabled>Seleccione</option>

                                                                                {
                                                                                    CONFIGURACIONES.INIT.LIST.GENEROS.map((el, index) => (
                                                                                        <option key={index}
                                                                                                value={el.id}>{el.nombre}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <small
                                                                                className="invalid-feedback"> {errors[`genero_${inter.id}`]?.message}</small>
                                                                        </div>
                                                                    </div>}

                                                                    {!inter.isRenderRazonSocial && <div className="col-xs-12 col-md-3">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`estadoCivil_${inter.id}`}
                                                                                   className="control-label col-form-label">Estado
                                                                                Civil <span
                                                                                    className="text-danger">*</span></label>
                                                                            <select
                                                                                {...register(`estadoCivil_${inter.id}`, {
                                                                                    required: OWASP.REQUIRED,
                                                                                    onChange: (e) => {

                                                                                    },
                                                                                    disabled: inter.isBloqueado
                                                                                })} className="form-control" id={`estadoCivil_${inter.id}`}
                                                                                defaultValue={""}
                                                                            >
                                                                                <option value="" disabled>Seleccione</option>
                                                                                {
                                                                                    CONFIGURACIONES.INIT.LIST.ESTADOS_CIVIL.map((el, index) => (
                                                                                        <option key={index}
                                                                                                value={el.id}>{el.nombre}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <small
                                                                                className="invalid-feedback"> {errors[`estadoCivil_${inter.id}`]?.message}</small>
                                                                        </div>
                                                                    </div>}

                                                                    <div className="col-sm-12 col-md-2">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`celular_${inter.id}`} className="control-label col-form-label">Celular <span className="text-danger">*</span></label>
                                                                            <input
                                                                                {...register(`celular_${inter.id}`, {
                                                                                    required: OWASP.REQUIRED,
                                                                                    pattern: {
                                                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                                    },
                                                                                    disabled: inter.isBloqueado
                                                                                })}
                                                                                type="tel" className="form-control" id={`celular_${inter.id}`} placeholder="" maxLength={12} />
                                                                            <small className="invalid-feedback"> { errors[`celular_${inter.id}`]?.message }</small>
                                                                        </div>
                                                                    </div>

                                                                    <div className={`col-sm-12 ${inter.isRenderRazonSocial?'col-md-6':'col-md-10'}`}>
                                                                        <div className="form-group">
                                                                            <label htmlFor={`correoElectronico_${inter.id}`} className="control-label col-form-label">Email </label>
                                                                            <input
                                                                                {...register(`correoElectronico_${inter.id}`, {
                                                                                    pattern: {
                                                                                        value: OWASP.VALIDATIONS.EMAIL,
                                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                                    },
                                                                                    disabled: inter.isBloqueado
                                                                                })}
                                                                                type="email" className="form-control" id={`correoElectronico_${inter.id}`} placeholder="" />
                                                                            <small className="invalid-feedback"> { errors[`correoElectronico_${inter.id}`]?.message }</small>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                                <div className="action-form mt-3 pr-0 mr-0 d-flex justify-content-start">
                                                                    <WaveButton type="button" className="btn btn-sm btn-outline-danger waves-effect" onClick={() => fnDeleteInterviniente(inter.id)}>
                                                                        <i className="mdi mdi-delete"></i> Eliminar
                                                                    </WaveButton>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                    </div>
                                                </React.Fragment>
                                            ))}

                                        </div>
                                    </div>
                                </div>

                                <hr className="bg-success pb-1" />
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="d-flex align-items-center pb-2">
                                            <h6 className="mr-2 mb-0">Domicilio</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="departamentoCodigo" className="control-label col-form-label">Departamento <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("departamentoCodigo", {
                                                            required: OWASP.REQUIRED,
                                                            onChange:(e) => {
                                                                setValue("provinciaCodigo", '');
                                                                setValue("distritoCodigo", '');
                                                                changeDepartamento(e.target.value);
                                                            },
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            disabled: isBloqueado
                                                        })} className="form-control" id="departamentoCodigo"
                                                        defaultValue={""}
                                                    >
                                                        <option value="" disabled>Seleccione</option>
                                                        {
                                                            departamentos.map((el, index) => (
                                                                <option key={index} value={el.codigo}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.departamentoCodigo && errors.departamentoCodigo.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="provinciaCodigo" className="control-label col-form-label">Provincia <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("provinciaCodigo", {
                                                            required: OWASP.REQUIRED,
                                                            onChange:(e) => {
                                                                setValue("distritoCodigo", '');
                                                                changeProvincia(e.target.value);
                                                            },
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            disabled: isBloqueado
                                                        })} className="form-control" id="provinciaCodigo"
                                                        defaultValue={""}
                                                    >
                                                        <option value="" disabled>Seleccione</option>
                                                        {
                                                            provincias.map((el, index) => (
                                                                <option key={index} value={el.codigo}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.provinciaCodigo && errors.provinciaCodigo.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="distritoCodigo" className="control-label col-form-label">Distrito <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("distritoCodigo", {
                                                            required: OWASP.REQUIRED,
                                                            onChange:(e) => {
                                                            },
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            disabled: isBloqueado
                                                        })} className="form-control" id="distritoCodigo"
                                                        defaultValue={""}
                                                    >
                                                        <option value="" disabled>Seleccione</option>
                                                        {
                                                            distritos.map((el, index) => (
                                                                <option key={index} value={el.codigo}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.distritoCodigo && errors.distritoCodigo.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label htmlFor="direccion" className="control-label col-form-label">Dirección <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("direccion", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.GENERAL,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            disabled: isBloqueado
                                                        })}
                                                        type="text" className="form-control" id="direccion" placeholder="" readOnly onClick={fnShowAddress} />
                                                    <small className="invalid-feedback"> { errors.direccion && errors.direccion.message }</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <div className="d-flex align-items-center pb-2">
                                            <h6 className="mr-2 mb-0">Negocio o Centro Laboral</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="negocioDepartamentoCodigo" className="control-label col-form-label">Departamento <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("negocioDepartamentoCodigo", {
                                                            required: OWASP.REQUIRED,
                                                            onChange:(e) => {
                                                                setValue("negocioProvinciaCodigo", '');
                                                                setValue("negocioDistritoCodigo", '');
                                                                changeDepartamentoNegocio(e.target.value);
                                                            },
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            disabled: isBloqueado
                                                        })} className="form-control" id="negocioDepartamentoCodigo"
                                                        defaultValue={""}
                                                    >
                                                        <option value="" disabled>Seleccione</option>
                                                        {
                                                            departamentos.map((el, index) => (
                                                                <option key={index} value={el.codigo}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.negocioDepartamentoCodigo && errors.negocioDepartamentoCodigo.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="negocioProvinciaCodigo" className="control-label col-form-label">Provincia <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("negocioProvinciaCodigo", {
                                                            required: OWASP.REQUIRED,
                                                            onChange:(e) => {
                                                                setValue("negocioDistritoCodigo", '');
                                                                changeProvinciaNegocio(e.target.value);
                                                            },
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            disabled: isBloqueado
                                                        })} className="form-control" id="negocioProvinciaCodigo"
                                                        defaultValue={""}
                                                    >
                                                        <option value="" disabled>Seleccione</option>
                                                        {
                                                            negocioProvincias.map((el, index) => (
                                                                <option key={index} value={el.codigo}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.negocioProvinciaCodigo && errors.negocioProvinciaCodigo.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="negocioDistritoCodigo" className="control-label col-form-label">Distrito <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("negocioDistritoCodigo", {
                                                            required: OWASP.REQUIRED,
                                                            onChange:(e) => {
                                                            },
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            disabled: isBloqueado
                                                        })} className="form-control" id="negocioDistritoCodigo"
                                                        defaultValue={""}
                                                    >
                                                        <option value="" disabled>Seleccione</option>
                                                        {
                                                            negocioDistritos.map((el, index) => (
                                                                <option key={index} value={el.codigo}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.negocioDistritoCodigo && errors.negocioDistritoCodigo.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label htmlFor="negocioDireccion" className="control-label col-form-label">Dirección <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("negocioDireccion", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.GENERAL,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            disabled: isBloqueado
                                                        })}
                                                        type="text" className="form-control" id="negocioDireccion" placeholder="" readOnly onClick={fnShowAddressNegocio} />
                                                    <small className="invalid-feedback"> { errors.negocioDireccion && errors.negocioDireccion.message }</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="fuenteIngreso" className="control-label col-form-label">Fuente de Ingreso <span className="text-danger">*</span></label>
                                            <select
                                                {...register("fuenteIngreso", {
                                                    required: OWASP.REQUIRED,
                                                    onChange:(e) => {
                                                        setValue("actividadLaboral", '');
                                                        setValue("actividadNegocioId", '');
                                                        setDataActividadNegocio(CONFIGURACIONES.INIT.NULL);
                                                    },
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.GENERAL,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    disabled: isBloqueado
                                                })} className="form-control" id="fuenteIngreso"
                                                defaultValue={""}
                                            >
                                                <option value="" disabled>Seleccione</option>
                                                {
                                                    CONFIGURACIONES.INIT.LIST.FUENTES_DE_INGRESO.map((el, index) => (
                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <small className="invalid-feedback"> { errors.fuenteIngreso && errors.fuenteIngreso.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="actividadLaboral" className="control-label col-form-label">Actividad Laboral <span className="text-danger">*</span></label>
                                            <div className="input-group">
                                                <input
                                                    {...register("actividadLaboral", {
                                                        required: OWASP.REQUIRED,
                                                        onChange:(e) => {
                                                        },
                                                        pattern: {
                                                            value: OWASP.VALIDATIONS.GENERAL,
                                                            message: OWASP.MESSAGES.DEFAULT
                                                        },
                                                        disabled: isBloqueado
                                                    })} type="text" className="form-control" id="actividadLaboral" readOnly
                                                />
                                                <input type="hidden" name="actividadNegocioId" {...register("actividadNegocioId", { required: OWASP.REQUIRED })}/>
                                                <div className="input-group-append">
                                                    <WaveButton className="btn btn-outline-success" type="button" dataTooltipId="data_actividadLaboral" content="Seleccione"
                                                                onClick={fnShowActividadNegocio}>
                                                        <i className="mdi mdi-auto-upload"></i>
                                                    </WaveButton>
                                                </div>
                                            </div>
                                            <small className="invalid-feedback"> { errors.actividadLaboral && errors.actividadLaboral.message }</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="action-form mt-3 d-flex justify-content-start">
                            <div className="form-group m-0 p-0 text-left">
                                <WaveButton type="button" onClick={ fnReset } className="btn btn-sm btn-outline-danger waves-effect">
                                    <i className="mdi mdi-arrow-left"></i> Descartar
                                </WaveButton>

                                {showCreate && isSearchData && <WaveButton type="submit" className="ml-2 btn btn-sm btn-success waves-effect">
                                    <i className="mdi mdi-content-save-settings"></i> Guardar
                                </WaveButton>}
                            </div>
                        </div>
                    </form>

                    <AddressModal show={showAddressHome} data={dataAddressHome} onSave={fnSaveAddressHome} onClose={fnCloseAddress} showCreate={true} title={"Detalles de Domicilio"} centrosPoblado={centrosPoblado}/>
                    <AddressModal show={showAddressNegocio} data={dataAddressNegocio} onSave={fnSaveAddressNegocio} onClose={fnCloseAddressNegocio} showCreate={true} title={"Detalles de Negocio o Centro Laboral"} centrosPoblado={centrosPoblado}/>
                    <ActividadLaboralModal show={showActividadLaboral} data={dataActividadNegocio} onSave={fnSaveActividadNegocio} onClose={fnCloseActividadNegocio} showCreate={true} title={"Seleccione Actividad Laboral"} list={actividadLaboralFilter}/>
                </div>
            </>
            }
        </>
    )
}
export default MantProspeccion;